// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ffRFKUPaY5h8tnWk2vjMlg\\=\\={margin-top:1rem;width:100%;margin-bottom:0rem}", "",{"version":3,"sources":["webpack://./src/components/common/SecondaryButton/SecondaryButton.module.scss"],"names":[],"mappings":"AAGA,4BACE,eAAA,CACA,UAAA,CACA,kBAAA","sourcesContent":["\n                @import '~@purple/style-library/sass/base/base';\n              \n.secondary-button {\n  margin-top: 1rem;\n  width: 100%;\n  margin-bottom: 0rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"secondary-button": "ffRFKUPaY5h8tnWk2vjMlg=="
};
export default ___CSS_LOADER_EXPORT___;
